/* src/app/shared/ui/components/inputs/time-picker/time-picker.component.scss */
.container__label {
  min-height: 14px;
  -webkit-user-select: none;
  user-select: none;
  font-size: 1.2rem;
  color: #707070;
  margin-inline-start: 10px;
  margin-bottom: 4px;
}
.container__input-wrapper {
  font-size: 1.6rem;
  color: #707070;
  padding: 0 10px;
  border: 1px solid #b4b4b4;
  border-radius: 8px;
  height: 3.2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  outline: none;
  transition: all 0.12s linear;
}
.container__input-wrapper--disabled {
  color: #b4b4b4;
  border: 1px solid #b4b4b4 !important;
  cursor: not-allowed;
}
.container__input-wrapper--disabled ::placeholder {
  color: #b4b4b4;
}
.container__input-wrapper--disabled:hover {
  border: 1px solid #b4b4b4 !important;
}
.container__input-wrapper--required {
  border-color: #f94a44 !important;
}
.container__input-wrapper:hover {
  border: 1px solid #607bee;
}
.container__input-wrapper:focus-within {
  border-color: #607bee;
}
.container__input {
  height: inherit;
  background: transparent;
  font-size: 1.6rem;
  font-family: Rubik, serif;
  font-weight: 400;
  border: none;
  outline: none;
  flex: 1;
  width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.container__input--disabled {
  color: #b4b4b4 !important;
  cursor: not-allowed;
}
.container__input--disabled-with-value {
  cursor: not-allowed;
  color: black;
}
.container__icon {
  width: 16px;
  height: 16px;
}
.container__text-wrapper {
  height: 0;
  font-size: 1rem;
}
.container__text {
  font-weight: 500;
  font-size: 1.2rem;
  position: relative;
  top: 4px;
  right: 10px;
}
.container__text--error {
  color: #f94a44;
}
.container__text--hint {
  color: #607bee;
}
:host-context([dir=ltr]) .container__text {
  right: 0;
  left: 10px;
}
/*# sourceMappingURL=time-picker.component.css.map */
